import { useState } from "react";
import roadmap from "../assets/Road Map.png";
import satmap from "../assets/SatMap.png";
import aeromap from "../assets/AeroMap.png";
import { useDispatch, useSelector } from "react-redux";
import { changBaseLayers } from "./mapSlice";
import { RootState } from "../store";

interface MapTypePopUp {
  selectedType: string
  onSelect: (type: string) => void
  isSideNavExpanded: boolean
}

const MapTypePopUp = ({ selectedType, onSelect, isSideNavExpanded }: MapTypePopUp) => {
  const dispatch = useDispatch();

  const handleSelect = (type: string) => {
    dispatch(changBaseLayers(type));
    onSelect(type);
  };

  return (
    <div
      className={`absolute bottom-6 left-28
        z-[999] flex gap-x-2 p-2 bg-gray-900 rounded-lg shadow-md`}
      style={{ width: "fit-content" }}
    >
      {selectedType !== "maps-road" && (
        <button
          className="h-20 w-20 flex flex-col items-center justify-center cursor-pointer 
            focus:outline-none rounded-lg shadow-sm bg-twsBlue/20"
          onClick={() => handleSelect("maps-road")}
        >
          <img src={roadmap} alt="Roadmap" className="h-12 w-12 mb-1 rounded-md" />
          <span className="text-xs font-semibold uppercase text-twsBlue">Road</span>
        </button>
      )}
      {selectedType !== "maps-satellite" && (
        <button
          className="h-20 w-20 flex flex-col items-center justify-center cursor-pointer 
            focus:outline-none rounded-lg shadow-sm bg-twsBlue/20"
          onClick={() => handleSelect("maps-satellite")}
        >
          <img src={satmap} alt="Satellite" className="h-12 w-12 mb-1 rounded-md" />
          <span className="text-xs font-semibold uppercase text-twsBlue">Satellite</span>
        </button>
      )}
      {selectedType !== "maps-sectional" && (
        <button
          className="h-20 w-24 flex flex-col items-center justify-center cursor-pointer 
            focus:outline-none rounded-lg shadow-sm bg-twsBlue/20"
          onClick={() => handleSelect("maps-sectional")}
        >
          <img src={aeromap} alt="Aeronautical" className="h-12 w-12 mb-1 rounded-md" />
          <span className="text-xs font-semibold uppercase text-twsBlue">Aeronautical</span>
        </button>
      )}
    </div>
  );
};

export const MapTypeButton = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [selectedType, setSelectedType] = useState("maps-road");
  const darkMode = useSelector((state: RootState) => state.mapState.darkMode)
  const handleSelect = (type: string) => {
    setSelectedType(type);
    setShowPopup(false);
  };
  const isSideNavExpanded = useSelector((state: RootState) => state.sideNav.expanded)

  return (
    <>
      <div
        className={`absolute bottom-0 left-12
          z-[999]  transform -translate-y-1/2 flex flex-col bg-gray-900 p-1 items-center rounded-lg`}>
        <button
                className={`border-2 border-twsBlue/90 rounded-lg h-14 w-14 items-center flex 
                  flex-col justify-center cursor-pointer focus:outline-none`}
          onClick={() => setShowPopup(!showPopup)}
          aria-label="Toggle Map Type Popup" 
        >
          <img
            src={
              selectedType === "maps-road"
                ? roadmap
                : selectedType === "maps-satellite"
                ? satmap
                : aeromap
            }
            alt={selectedType}
            className="h-14 w-14 rounded-md"
          />
                
        </button>
        
        <span
          className={`text-center text-xs font-semibold uppercase text-twsBlue/90 ${
              darkMode ? "text-white" : "text-black"
          }`}
          >
          {selectedType === "maps-road"
              ? "Road"
              : selectedType === "maps-satellite"
              ? "Satellite"
              : "Aero"}
        </span>
      </div>
      {showPopup && (
        <div className="ml-4">
          <MapTypePopUp 
            selectedType={selectedType} 
            isSideNavExpanded={isSideNavExpanded} 
            onSelect={handleSelect} 
            />
        </div>
      )}
    </>
  );
};
